import createWrappedField from './createWrappedField'
import GridField from '../GridField'

export default createWrappedField({
  Component: GridField,
  name: 'DDIGrid',
  //wrapperStyle: {}
})
